/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerListQueryResponse, BidLevelingsControllerListQueryParams, BidLevelingsControllerList401, BidLevelingsControllerList403 } from "../../models/bidsController/BidLevelingsControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { bidLevelingsControllerList } from "../../clients/bidsService/bidLevelingsControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const bidLevelingsControllerListQueryKey = (params: BidLevelingsControllerListQueryParams) => [{
  url: '/api/v1/bid-levelings'
}, ...(params ? [params] : [])] as const;
export type BidLevelingsControllerListQueryKey = ReturnType<typeof bidLevelingsControllerListQueryKey>;
export function bidLevelingsControllerListQueryOptions(params: BidLevelingsControllerListQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = bidLevelingsControllerListQueryKey(params);
  return queryOptions<BidLevelingsControllerListQueryResponse, ResponseErrorConfig<BidLevelingsControllerList401 | BidLevelingsControllerList403>, BidLevelingsControllerListQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return bidLevelingsControllerList(params, config);
    }
  });
}

/**
 * @summary List a project's trades with their status and attention count
 * {@link /api/v1/bid-levelings}
 */
export function useBidLevelingsControllerList<TData = BidLevelingsControllerListQueryResponse, TQueryData = BidLevelingsControllerListQueryResponse, TQueryKey extends QueryKey = BidLevelingsControllerListQueryKey>(params: BidLevelingsControllerListQueryParams, options: {
  query?: Partial<QueryObserverOptions<BidLevelingsControllerListQueryResponse, ResponseErrorConfig<BidLevelingsControllerList401 | BidLevelingsControllerList403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? bidLevelingsControllerListQueryKey(params);
  const query = useQuery({
    ...bidLevelingsControllerListQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BidLevelingsControllerList401 | BidLevelingsControllerList403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}